import ModalItem from './ModalItem';

export default function DirectDeposit({ fields }) {
  return (
    <>
      {fields.map((field) => <ModalItem field={field} key={field.value} />)}
    </>
  );
}
